import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { moment } from 'util/dateTime';
import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS } from 'util/tracking_constants';

import ManagerNotesPaywall from '../ManagerNotesPaywall';
import Section from '../Section';
import {
  getMinTierNameForTimecardNotesFeature,
  getTimecardNotesEnabled,
} from '../selectors';

import AddNote from './AddNote';
import Note from './Note';

const { cx, cxEl } = cxHelpers('NoteSection');

const placeholder = toI18n('timecard_modal.manager_notes.placeholder');

const renderAddNote = (shiftId, managerNotesEnabled, tierName) =>
  managerNotesEnabled ? (
    <AddNote shiftId={shiftId} placeholder={placeholder} />
  ) : (
    <ManagerNotesPaywall tierName={tierName} trackUpgradeClicked />
  );

const expandedContent = (
  notes,
  className,
  shiftId,
  rating,
  body,
  title,
  employeeName,
  managerNotesEnabled,
  tierName
) =>
  notes.isEmpty() ? (
    <Box>
      {(rating || body) && (
        <Note
          employeeName={employeeName}
          title={title}
          noteBody={body}
          rating={rating}
          className={className}
        />
      )}
      {renderAddNote(shiftId, managerNotesEnabled, tierName)}
    </Box>
  ) : (
    <Box column gap={16}>
      {rating && (
        <Note
          employeeName={employeeName}
          noteBody={body}
          rating={rating}
          title={title}
          className={className}
        />
      )}
      {notes.map(note => (
        <Note
          note={note}
          key={note.get('id')}
          className={className}
          eventType={note.get('event_type')}
          noteBody={note.get('body') || note.get('message')}
          date={moment(note.get('created_at'))}
        />
      ))}
      {renderAddNote(shiftId, managerNotesEnabled, tierName)}
    </Box>
  );

const NoteSection = ({
  notes,
  shiftId,
  feedback,
  employeeName,
  managerNotesEnabled,
  tierName,
}) => {
  const className = cxEl('note');

  const additionalNoteCount =
    feedback?.get('body') || feedback?.get('rating') ? 1 : 0;

  const titleText = () =>
    toI18n('timecard_modal_v3.note_section.title', {
      props: { count: notes.count() + additionalNoteCount },
    });

  return (
    <Box className={cx()}>
      <Section
        trackingAction={EVENT_ACTIONS.NOTES_HISTORY_CLICKED_V3}
        title={titleText()}
        iconName="Documents"
        expandedContent={expandedContent(
          notes,
          className,
          shiftId,
          feedback?.get('rating'),
          feedback?.get('body'),
          feedback?.get('title'),
          employeeName,
          managerNotesEnabled,
          tierName
        )}
        collapsedContent={null}
        bottomBorder
        bottomPadding
      />
    </Box>
  );
};

NoteSection.propTypes = {
  notes: ImmutablePropTypes.list,
  shiftId: PropTypes.number.isRequired,
  rating: PropTypes.number,
  feedback: PropTypes.string,
  employeeName: PropTypes.string,
  managerNotesEnabled: PropTypes.bool.isRequired,
  tierName: PropTypes.string.isRequired,
};

export default connect((state, props) => ({
  managerNotesEnabled: getTimecardNotesEnabled(state, props),
  tierName: getMinTierNameForTimecardNotesFeature(state, props),
}))(NoteSection);
